import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SearchLiteraturesService } from '../../core/search-literatures.service';

@Component({
  selector: 'search-literatures-counter-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './search-page-counter-pagination.component.html',
  styleUrls: ['./search-page-counter-pagination.component.scss'],
})
export class SearchLiteraturesCounterPaginationComponent {
  currentPageData = this.searchLiteraturesService.get();

  constructor(private searchLiteraturesService: SearchLiteraturesService) {}

  getDisplayValue(totalResults: number, pageSize: number): { display: number; total: number } {
    const display = totalResults <= pageSize ? totalResults : pageSize;
    return { display, total: totalResults };
  }
}
